import { activePhoneRegex, phoneRegex } from '@hilma/netina2all';
import { isMobilePhone, length } from 'class-validator';

import { createRules } from '../../functions';

export const loginPhoneRules = createRules({
	phone: {
		name: i18n => i18n.assoRl.phone,
		regex: phoneRegex,
		activeRegex: activePhoneRegex,
		activeRegexErr: i18n => i18n.errText.numbersOnly,
		required: true,
		length: 10,
		classValidator: (value: string) => length(value, 10, 10) && isMobilePhone(value, 'he-IL') && (new RegExp(/^\d+/)).test(value)
	},
});

export const loginCodeRules = createRules({
	code: {
		name: i18n => i18n.login.code,
		length: 6,
		required: true,
	}
});

export const loginDialogRules = createRules({
	code: {
		name: i18n => i18n.login.code,
		length: 6,
		required: true,
	}
});